<script>

  // Define boundaries for bar width (percentage)
  export let min = 40;
  export let max = 100;
  // Number of bars per loading item
  export let bars = 5;
  // Number of loading items
  export let items = 4;
  export let loaderStyle = '', barStyle = '';
</script>

<style> 
  .bar {
    position: relative;
    width: 80%;
    height: var(--space-2);
    margin-bottom: var(--space-2);
    overflow: hidden;
    border-radius: var(--round);
    background-color: var(--color-gray-200);
  }
  .bar:last-child {
    margin-bottom: 0;
  }
  .bar:after {
    content: "";
    display: block;
    position: absolute;
    height: 100%;
    width: var(--space-24);
    top: 0;
    animation: load var(--transition-speed-slow) var(--transition-curve)
      infinite;
    background-image: linear-gradient(
      to right,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.5) 50%,
      rgba(255, 255, 255, 0) 100%
    );
  }
  .bar-2 {
    width: 55%;
  }
  .bar-3 {
    width: 77%;
  }
  @keyframes load {
    from {
      left: -100px;
    }
    to {
      left: 100%;
    }
  }
</style>

<div class="container">
  {#each Array(items) as _}
    <div class="card {loaderStyle}">
      {#each Array(bars) as _, bar}
        <div style="width: {Math.random() * (max - min) + min}%" class="bar bar-{bar} {barStyle}" />
      {/each}
    </div>
  {/each}
</div>
